import React, { useState, useEffect } from 'react';
import { Layout, message } from 'antd';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from '../hooks/useMediaQuery';
import SidebarStatic from '../components/sidebar/AdminSidebar';
import CustomFooter from '../components/CustomFooter';
import CustomNavbar from '../components/CustomNavbar';
import AdminSidebar from '../components/sidebar/AdminSidebar';

const { Content } = Layout;

const AdminDashboardLayout = () => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [collapsed, setCollapsed] = useState(isMobile);
  const isLoggedIn = localStorage.getItem('logged_in') === 'true';
  const role = localStorage.getItem('user_role');

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  // Route Guard: Only allow admins
  if (!isLoggedIn || role !== 'admin') {
    if (role !== 'admin') {
      message.error('Access denied. Admins only.');
    }
    return <Navigate to={role === 'theater' ? "/theater" : "/"} replace state={{ from: location }} />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AdminSidebar
        trigger={null}
        collapsible={true}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <Layout
        style={{
          marginLeft: collapsed ? 0 : 250,
          transition: 'margin-left 0.2s',
          minHeight: '100vh',
        }}
      >
        <CustomNavbar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content style={{ margin: '24px 16px 0', overflow: 'auto' }}>
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: '#fff',
              borderRadius: '8px',
            }}
          >
            <Outlet />
          </div>
        </Content>
        <CustomFooter />
      </Layout>
    </Layout>
  );
};

export default AdminDashboardLayout;

